"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../common/util/constants/messages"));
const ProviderLogo = ({ intl, url, affiliation }) => {
    return (react_1.default.createElement("img", { src: url, itemProp: "logo", alt: intl.formatMessage(messages_1.default.arialogo, { affiliation }) }));
};
exports.default = (0, intl_1.injectIntl)(ProviderLogo);
//# sourceMappingURL=ProviderLogo.js.map